<template>
  <div class="saved-model">
    <div class="info">
      <b-form-radio :value="model.id" name="saved_model" v-model="radioValue">{{
          model.title
        }}</b-form-radio>
      <div class="extra-info">
        <p class="subject" v-if="model.subject">{{ model.subject }}</p>
        <p class="type" v-if="model.type">{{ getType(model.type) }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mixins: [],
  data() {
    return {
      radioValue: false,
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
    };
  },
  props: {
    model: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {},
  methods: {
    getType(value) {
      return this.types.find((type) => type.value === value).text;
    },
  },
  components: {},
};
</script>
<style scoped>
.saved-model {
  display: grid;
  grid-template-columns: 1fr 40px;
  /* grid-template-rows: repeat(2, 1fr); */
  grid-column-gap: 0px;
  /* grid-row-gap: 0px; */
  padding: 10px 15px 20px;
  border-bottom: 1px solid var(--gray-600);
  margin: 0;
  width: calc(100% - 15px);
  transition: background 0.2s linear;
  &:has(input[type="radio"]:checked) {
    background: #fff;
  }
  &:last-of-type {
    border: 0;
  }
  .subject {
    font-size: 13px;
    padding: 0 5px 0 0;
    line-height: 1.5em;
  }
  .extra-info {
    padding-left: 1.5rem;
  }
  .subject {
    margin: 0;
  }
  .info {
    grid-area: 1 / 1 / 2 / 2;
  }
  .type {
    color: var(--color-text-muted);
  }
}
</style>
<style>
#modalScegliModelliEmail .custom-control-label {
  font-size: var(--font-size-md);
  color: #000;
}
</style>